/* eslint-disable react/require-default-props */
/* eslint-disable react/default-props-match-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import s from './InfoGraphicMobile.scss';

class InfoGraphicMobile extends React.PureComponent {
  render() {
    const { nextLinks } = this.props;

    const nextLinksArr = [];
    if (nextLinks && nextLinks.length > 0) {
      nextLinks.forEach(link => {
        const imgSrc = `https://static.toiimg.com/thumb/msid-${link.msid}/${
          link.msid
        }.jpg?resizemode=1&width=180&height=130`;
        nextLinksArr.push(
          <li>
            <Link href={link.wu || link.su} spa={!!link.isspa}>
              <img src={imgSrc} alt={link.value} />
              <span>{link.value}</span>
            </Link>
          </li>,
        );
      });
    }

    if (nextLinksArr.length > 0) {
      return (
        <div
          className={`${s.infographic_box} ${
            this.props.theme ? s[this.props.theme] : ''
          }`}
        >
          <h3>
            Latest infographics{' '}
            <span>
              <Link href="/infographics.cms" spa>
                More
              </Link>
            </span>
          </h3>
          <div className={s.infographic_inner}>
            <ul>{nextLinksArr}</ul>
          </div>
        </div>
      );
    }
    return null;
  }
}

InfoGraphicMobile.propTypes = {
  nextLinks: PropTypes.shape({}).isRequired,
  theme: PropTypes.string,
};

InfoGraphicMobile.defaultProps = {
  theme: '',
};

export default InfoGraphicMobile;
